export default "__VITE_ASSET__40fe8895__"